import {Component} from "@angular/core";
import {FUIButtonComponent} from "../button.component";

@Component({
    selector: "fui-action-button",
    styleUrls: ["./action-button.component.scss"],
    templateUrl: "./action-button.component.html"
})
export class FUIActionButtonComponent extends FUIButtonComponent {

}
